import { DecimalPipe } from '@angular/common';
import { Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges, ViewChildren } from '@angular/core';
import { mongoId } from '../../../../../@core/common/global';
import { ApiService } from '../../../../../@core/service/api.service';
import { CompilationModel } from '../../../../../@models/erp/compilation';
import { CompilationTypeData, DocConfig, UnitData } from '../../../../../@models/erp/compilationData';
import { LineItemModel } from '../../../../../@models/erp/lineItem';
import { RoundPipe } from '../../../../../@theme/pipes';
import { DocMetrics } from '../line-item-metrics/line-item-metrics.component';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';

@Component({
  selector: 'ngx-line-item-info-box',
  templateUrl: './line-item-info-box.component.html',
  styleUrls: ['./line-item-info-box.component.scss'],
})
export class LineItemInfoBoxComponent implements OnInit, DoCheck, OnChanges {

  @Input() compilation: CompilationModel;
  @Input() lineItem: LineItemModel;
  @Input() summary = false;

  unitData = UnitData;

  static boxes = [];
  get boxesExist() {
    return LineItemInfoBoxComponent.boxes.length ? true : null;
  }

  static currentCompilation: CompilationModel;

  static sum: {
    unit: string,
    price: any,
    turnover: any,
    // minPrice: any,
    minTurnover: any,
    netProfit: any,
    profitPercent: any,
    currency: string,
    pos: number,
    incomplete: boolean,
  }

  info: {
    unit: string,
    price: any,
    turnover: any,
    // minPrice: any,
    minTurnover: any,
    netProfit: any,
    profitPercent: any,
    currency: string,
    pos: number,
    incomplete: boolean,
  }

  prevLineItem: LineItemModel;
  prevDeductibleSum: number;

  constructor(private api: ApiService, private data: SharedDataService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.summary && changes.compilation && changes.compilation.currentValue) {
      if (LineItemInfoBoxComponent.currentCompilation !== this.compilation) {
        LineItemInfoBoxComponent.currentCompilation = this.compilation;
        LineItemInfoBoxComponent.boxes = [];
      }
      if (this.lineItem && !this.prevLineItem) this.prevLineItem = JSON.parse(JSON.stringify(this.lineItem));
      this.reloadData();
    }
  }

  testcount = 0

  ngDoCheck(): void {
    if (!this.summary && (!this.compilation || !this.lineItem)) return;

    if (this.summary) {
      const dsum = (this.compilation.deductibleItems && this.compilation.deductibleItems.reduce((a, c) => a + (c && c.value || 0), 0)) || 0;
      if (this.prevDeductibleSum !== dsum) {
        this.prevDeductibleSum = dsum;
        this.loadSummary();
      }
      this.info = this.boxesExist && LineItemInfoBoxComponent.sum;
      // this.prevLineItem = JSON.parse(JSON.stringify(this.lineItem));
    } else if (
      this.prevLineItem
      && mongoId(this.lineItem.finishedProduct) !== mongoId(this.prevLineItem.finishedProduct)
      || this.lineItem.quantity !== this.prevLineItem.quantity
      || this.lineItem.piecePrice !== this.prevLineItem.piecePrice
      || this.lineItem.discount !== this.prevLineItem.discount
    ) {
      this.prevLineItem = JSON.parse(JSON.stringify(this.lineItem));
      this.reloadData()
    }
  }

  async reloadData() {

    if (!this.compilation || !this.lineItem || !this.compilation.recipient || !this.lineItem.finishedProduct) return;

    const pricetype = DocConfig.get('prices').docs.indexOf(CompilationTypeData.get(this.compilation.type).code);

    const data = await this.api.loadPrice(
      this.compilation.issuer,
      mongoId(this.compilation.recipient),
      mongoId(this.lineItem.finishedProduct),
      new Date(),
      this.compilation.currency,
      DocConfig.get('prices').price[pricetype] === 'SP'
    )

    if (!data) return;

    const dm = new DocMetrics(this.api, this.compilation, this.lineItem, new RoundPipe(), this.data)
    const piecePrice = dm.metrics.convert(+data.value, 1, +data.type) || 0;
    const minPiecePrice = piecePrice// dm.metrics.convert(+data.minValue, 1, +data.type) || 0;

    const discount =  (100 - (+this.lineItem.discount))/100;
    const turnover = this.lineItem.quantity * piecePrice * discount;
    const minTurnover = minPiecePrice * this.lineItem.quantity;

    this.info = data && {
      unit: data.type && (UnitData.get(+data.type) || {} as any).name,
      price: +data.value || 0,
      turnover: turnover,
      // minPrice: +data.minValue || 0,
      minTurnover: minTurnover,
      netProfit: minTurnover ? turnover - minTurnover : '',
      profitPercent: minTurnover ? 100 * (1 - minTurnover / turnover) : '',
      currency: this.compilation.currency,
      pos: this.lineItem.position.internalPos,
      incomplete: !minTurnover,
    }

    LineItemInfoBoxComponent.boxes[this.lineItem.position.internalPos] = this.info;
    this.loadSummary();
  }

  loadSummary() {
    const turnover = LineItemInfoBoxComponent.boxes
      .filter(f => f.minTurnover &&
        !(this.compilation.optionalLineItems && this.compilation.optionalLineItems.map(m => m.position.internalPos).includes(f.pos)))
      .reduce((a, c) => a + (c && c.turnover || 0), 0)
        + this.compilation.deductibleItems.reduce((a, c) => a + (c && c.value || 0), 0);
    const minTurnover = LineItemInfoBoxComponent.boxes
      .filter(f => f.minTurnover &&
        !(this.compilation.optionalLineItems && this.compilation.optionalLineItems.map(m => m.position.internalPos).includes(f.pos)))
      .reduce((a, c) => a + (c && c.minTurnover || 0), 0);

    LineItemInfoBoxComponent.sum = LineItemInfoBoxComponent.boxes.length && {
      unit: null,
      price: null,
      turnover: turnover,
      // minPrice: null,
      minTurnover: minTurnover,
      netProfit: turnover - minTurnover,
      profitPercent: 100 * (1 - minTurnover / turnover),
      currency: this.compilation.currency,
      pos: null,
      incomplete: LineItemInfoBoxComponent.boxes.find(f => f && f.incomplete),
    }
  }

}
